import { IonContent, IonPage } from '@ionic/react';
import Rating from '../components/c-rating';
import Pill from '../components/c-pill';

export default function Thanks() {
	return (
		<IonPage>
			<IonContent fullscreen>
				<div className='w-full min-h-full h-auto justify-items-center items-center flex flex-col bg-c-purple'>
					<img src='/assets/media/tela-8-mobile-1.png' className='mt-12' />
				</div>
				<p className='absolute w-full px-7 top-1/2 mt-20 text-center text-xl uppercase font-bar'>obrigado pela sua participação!</p>
			</IonContent>
		</IonPage>
	);
}
